/* Pick-your-set. Exactly `data-need` minis; the product form's add button
   stays disabled and labelled with what is left until then, and the chosen
   names ride on the line as properties[Mini 1..4]. */
class AnyraMinisPicker extends HTMLElement {
  connectedCallback() {
    this.need = parseInt(this.dataset.need || '4', 10);
    this.form = document.getElementById(this.dataset.form);
    this.checks = Array.from(this.querySelectorAll('[data-minis-check]'));
    this.countEl = this.querySelector('[data-minis-count]');
    this.chosenWrap = this.querySelector('[data-minis-chosen]');
    this.chosenList = this.querySelector('[data-minis-chosen-list]');
    this.button = this.form && this.form.querySelector('button[type="submit"], [name="add"]');
    this.labelEl = this.button && (this.button.querySelector('span:not(.visually-hidden)') || this.button);
    this.originalLabel = this.labelEl ? this.labelEl.textContent : '';
    this.checks.forEach(c => c.addEventListener('change', () => this.update()));
    if (this.form) this.form.addEventListener('submit', e => {
      if (this.inCart) { e.preventDefault(); e.stopImmediatePropagation(); this.say('One Minis set per order. Your set is already in the cart.'); return; }
      if (this.chosen().length !== this.need) { e.preventDefault(); this.update(true); }
    }, true);
    /* Client, 23 Sep: "Anyra Minis: Ensure only 1 set of 4 products can be
       purchased per customer/order." The cart is read on load and after every
       cart change, so the check on submit is synchronous and can stop the
       theme's own add handler, which listens on the same form. */
    this.inCart = false;
    const read = (cart) => { this.inCart = !!(cart && cart.items || []).find(i => i.handle === 'anyra-minis'); this.update(); };
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js').then(r => r.json()).then(read).catch(() => {});
    document.addEventListener('cart:updated', e => { if (e.detail && e.detail.cart && e.detail.cart.items) read(e.detail.cart); else fetch('/cart.js').then(r => r.json()).then(read).catch(() => {}); });
    document.body.classList.add('anyra-minis-active');
    this.update();
  }
  chosen() { return this.checks.filter(c => c.checked).map(c => c.value); }
  say(text) {
    let m = this.querySelector('[data-minis-note]');
    if (!m) { m = document.createElement('p'); m.className = 'anyra-minis__note'; m.setAttribute('data-minis-note', ''); m.setAttribute('role', 'status'); this.appendChild(m); }
    m.textContent = text;
  }
  update(shake) {
    if (!this.inCart) { const m = this.querySelector('[data-minis-note]'); if (m) m.remove(); }
    const picked = this.chosen();
    const n = picked.length;
    this.classList.toggle('anyra-minis--full', n >= this.need);
    this.checks.forEach(c => { if (!c.checked) c.disabled = c.hasAttribute('data-out') || n >= this.need; });
    if (this.countEl) this.countEl.textContent = n + ' of ' + this.need + ' chosen';
    if (this.chosenWrap) { this.chosenWrap.hidden = n === 0; if (this.chosenList) this.chosenList.textContent = picked.join(', '); }
    /* Properties on the form: one hidden input per pick, rewritten each time. */
    if (this.form) {
      this.form.querySelectorAll('input[data-minis-prop]').forEach(i => i.remove());
      picked.forEach((name, i) => {
        const inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'properties[Mini ' + (i + 1) + ']'; inp.value = name; inp.setAttribute('data-minis-prop', '1');
        this.form.appendChild(inp);
      });
    }
    if (this.button && this.inCart) {
      this.button.disabled = true;
      this.button.setAttribute('aria-disabled', 'true');
      if (this.labelEl) this.labelEl.textContent = 'Set in your cart';
      this.say('One Minis set per order. Your set is already in the cart.');
      return;
    }
    if (this.button) {
      const ready = n === this.need;
      this.button.disabled = !ready;
      /* The theme's product form bails on submit if the button has an
         aria-disabled attribute at all (theme.js handleFormSubmit uses
         hasAttribute), so "false" also blocked the add. Remove it when ready.
         This is why "Add my set" did nothing in the browser (client, 21 Sep
         P0 "Minis: dead Add Set button"; found 24 Sep). */
      if (ready) this.button.removeAttribute('aria-disabled'); else this.button.setAttribute('aria-disabled', 'true');
      const left = this.need - n;
      const label = ready ? this.dataset.labelReady : (n === 0 ? this.dataset.labelEmpty : this.dataset.labelPartial.replace('[n]', left));
      if (this.labelEl) this.labelEl.textContent = label;
      if (shake) { this.button.classList.add('anyra-minis__shake'); setTimeout(() => this.button.classList.remove('anyra-minis__shake'), 400); }
    }
  }
}
if (!customElements.get('anyra-minis-picker')) customElements.define('anyra-minis-picker', AnyraMinisPicker);
